/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useCan} from '../../../../../app/modules/auth/core/AdminPermissions'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const canDash = useCan('dashboard.view')
  const canUsers = useCan('user_mgmt.view')
  const canTrips = useCan('trip_mgmt.view')
  const canGifts = useCan('gift_card_mgmt.view')
  const canMates = useCan('mates_mgmt.view')
  const canWallet = useCan('wallet.view')
  const canPay = useCan('payment_mgmt.view')
  const canPricing = useCan('platform_pricing.view')
  const canFeedback = useCan('feedback.view')
  const canAdminUsers = useCan('admin_users.view')
  const canRoles = useCan('roles.view')
  const canAuditLogs = useCan('audit_logs.view')
  const canExplore = useCan('explore_more.view')
  const canImpact = useCan('impact_config.view')

  return (
    <>
      {canDash ? (
        <div className='menu-item pt-2 pb-2'>
          <div className='menu-content'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Overview</span>
          </div>
        </div>
      ) : null}
      {canDash ? (
        <>
          <SidebarMenuItem
            to='/dashboard'
            icon='category'
            title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
            fontIcon='bi-app-indicator'
          />
          <SidebarMenuItem
            to='/business-matrix'
            icon='chart-line'
            title='Business Matrix'
            fontIcon='bi-graph-up'
          />
        </>
      ) : null}

      {canUsers ||
      canTrips ||
      canGifts ||
      canMates ||
      canWallet ||
      canPay ||
      canPricing ||
      canFeedback ? (
        <>
          <div className='menu-item pt-6 pb-2'>
            <div className='menu-content'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Operations</span>
            </div>
          </div>
          {canUsers ? (
            <SidebarMenuItem
              to='/user-management'
              icon='profile-user'
              title='User Management'
              fontIcon='bi-people'
            />
          ) : null}
          {canTrips ? (
            <SidebarMenuItem
              to='/trip-management'
              icon='route'
              title='Trip Management'
              fontIcon='bi-map'
            />
          ) : null}
          {canGifts ? (
            <SidebarMenuItem
              to='/gift-card-management'
              icon='gift'
              title='Gift Card Management'
              fontIcon='bi-gift'
            />
          ) : null}
          {canMates ? (
            <SidebarMenuItem
              to='/mates-management'
              icon='people'
              title='Mates Management'
              fontIcon='bi-people'
            />
          ) : null}
          {canWallet ? (
            <SidebarMenuItem
              to='/wallet-management'
              icon='wallet'
              title='Wallet Management'
              fontIcon='bi-wallet'
            />
          ) : null}
          {canPay ? (
            <SidebarMenuItem
              to='/payment'
              icon='credit-cart'
              title='Payment Management'
              fontIcon='bi-credit-card'
            />
          ) : null}
          {canPricing ? (
            <SidebarMenuItem
              to='/platform-pricing'
              icon='dollar'
              title='Platform Pricing'
              fontIcon='bi-cash-coin'
            />
          ) : null}
          {canFeedback ? (
            <SidebarMenuItem
              to='/feedback-response'
              icon='message-text-2'
              title='Feedback Response'
              fontIcon='bi-chat-left-text'
            />
          ) : null}
        </>
      ) : null}

      {canExplore || canImpact ? (
        <>
          <div className='menu-item pt-6 pb-2'>
            <div className='menu-content'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Content</span>
            </div>
          </div>
          {canExplore ? (
            <SidebarMenuItemWithSub
              to='/explore-more'
              icon='compass'
              title='Explore More'
              fontIcon='bi-compass'
            >
              <SidebarMenuItem to='/explore-more/videos' title='Videos' hasBullet />
              <SidebarMenuItem to='/explore-more/blogs' title='Blogs' hasBullet />
              <SidebarMenuItem to='/explore-more/offers' title='Offers' hasBullet />
            </SidebarMenuItemWithSub>
          ) : null}
          {canImpact ? (
            <SidebarMenuItem
              to='/impact-config'
              icon='chart-simple'
              title='Impact Config'
              fontIcon='bi-bar-chart'
            />
          ) : null}
        </>
      ) : null}

      {canAdminUsers || canRoles || canAuditLogs ? (
        <>
          <div className='menu-item pt-8 pb-2'>
            <div className='menu-content'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                Admin &amp; Security
              </span>
            </div>
          </div>
          {canAdminUsers ? (
            <SidebarMenuItem
              to='/admin-users'
              icon='shield-tick'
              title='Admin Users'
              fontIcon='bi-people'
            />
          ) : null}
          {canRoles ? (
            <SidebarMenuItem
              to='/settings/roles'
              icon='security-user'
              title='Roles &amp; Permissions'
              fontIcon='bi-shield-lock'
            />
          ) : null}
          {canAuditLogs ? (
            <SidebarMenuItem
              to='/audit-logs'
              icon='notepad'
              title='Audit logs'
              fontIcon='bi-journal-text'
            />
          ) : null}
        </>
      ) : null}
    </>
  )
}

export {SidebarMenuMain}
